import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getReviewData,
  handleReview,
  checkEsignUrl,
  getDocumentId,
} from "./redux/action";
import Title from "../../components/Title";
import Button from "../../components/Button";
import "./style.css";
import "react-circular-progressbar/dist/styles.css";
import AddJointHolderModal from "./component/AddJointHolderModal";
import {
  CONSORTIUM_API_URL,
  showPrevBtnByUrl,
  getPrevAndNextRoute,
} from "utils";
import { updateNavigationKycStatus } from "../../../../redux/navigation/navigationAction";

const Review = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const stages = useSelector((state) => state.navigation.stagesData);
  const { showJointholderFlow } = useSelector((state) => state.jointholder);
  const { loading, dataSource } = useSelector((state) => state.review);
  const { inputLabelColor, themeTemplate } = useSelector(
    (state) => state.theme
  );
  const { kycStatus, kycPageName } = useSelector((state) => state.navigation);
  const [scroll, setScroll] = useState(1);
  const [showProgress, setshowProgress] = useState(false);
  const [progressTimer, setProgressTimer] = useState(100);

  const joint_holder = window.sessionStorage.getItem("joint_holder");
  useEffect(() => {
    dispatch(getReviewData());
  }, [dispatch]);

  useEffect(() => {
    let intervalId;
    if (progressTimer > 0 && showProgress) {
      intervalId = setInterval(() => {
        setProgressTimer((counter) => counter - 1);
      }, 100);
    }
    return () => clearInterval(intervalId);
  }, [progressTimer, showProgress]);

  const checkSuccessEsignCallback = () => {
    setshowProgress(false);
    setProgressTimer(0);
  };
  const checkfailedEsignCallback = () => {
    setProgressTimer(100);
  };

  useEffect(() => {
    if (progressTimer === 1) {
      dispatch(
        checkEsignUrl(checkSuccessEsignCallback, checkfailedEsignCallback)
      );
    }
  }, [progressTimer]);

  const handleShowProgress = () => {
    setshowProgress(true);
  };

  const handleSubmit = () => {
    dispatch(handleReview(handleShowProgress));
    setTimeout(() => {
      dispatch(
        updateNavigationKycStatus({
          pageName: "Review",
          status: 1,
        })
      );
    }, 1000);
  };

  const downloadPDF = (url, filename) => {
    fetch(url).then(async function (t) {
      const b = await t.blob();
      let a = document.createElement("a");
      a.href = URL.createObjectURL(b);
      a.setAttribute("download", filename?.split(" ").join("-"));
      a.click();
    });
  };

  const getApiUrl = () => {
    const portal_domain = window.sessionStorage.getItem("portal_domain");
    let API_URL = "";
    if (portal_domain) {
      API_URL = portal_domain.substring(0, portal_domain.length - 1);
    }
    return API_URL;
  };

  const goToTop = () => {
    if (scroll > 1) {
      let scrollIndex = scroll - 1;
      setScroll(scrollIndex);
      console.log("scrollIndex", scrollIndex);
      let el = document.querySelector(`#review-${scrollIndex}`);
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "end",
        });
      }
    }
  };

  const goToBottom = () => {
    if (scroll < 9) {
      let scrollIndex = scroll + 1;
      setScroll(scrollIndex);
      console.log("scrollIndex", scrollIndex);
      let el = document.querySelector(`#review-${scrollIndex}`);
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  };

  const getArrowStyle = (template) => {
    let style = {
      position: "absolute",
    };
    switch (template) {
      case "101":
        style = { ...style, top: "24%" };
        break;
      case "102":
      case "106":
        style = { ...style, top: "24%" };
        break;
      case "103":
      case "105":
      case "107":
      case "109":
        style = { ...style, top: "31%" };
        break;
      case "104":
        style = { ...style, top: "24%" };
        break;
      case "108":
        style = { ...style, top: "10%" };
        break;
      case "110":
        style = { ...style, top: "27%" };
        break;
      default:
    }
    return style;
  };

  const getSegmentList = () => {
    const filter = (dataSource.segments || []).filter(
      (y) => y.bse || y.nse || y.mcx || y.msei || y.ncdex
    );
    return filter;
  };

  const getAddress = (result) => {
    let res = [];
    if (result?.address_line1) {
      res.push(result.address_line1);
    }
    if (result?.address_line2) {
      res.push(result.address_line2);
    }
    if (result?.city) {
      res.push(result.city);
    }
    if (result?.state) {
      res.push(result.state);
    }
    if (result?.country) {
      res.push(result.country);
    }
    if (result?.pincode) {
      res.push(result.pincode);
    }
    return res.join(", ");
  };

  const getGuardianAddress = (result) => {
    let res = [];
    if (result?.guardian_address1) {
      res.push(result.guardian_address1);
    }
    if (result?.guardian_address2) {
      res.push(result.guardian_address2);
    }
    if (result?.guardian_city) {
      res.push(result.guardian_city);
    }
    if (result?.guardian_state) {
      res.push(result.guardian_state);
    }
    if (result?.guardian_country) {
      res.push(result.guardian_country);
    }
    if (result?.guardian_pincode) {
      res.push(result.guardian_pincode);
    }
    return res.join(", ");
  };

  console.log(joint_holder)
  if (joint_holder == 1) {
    if (!stages?.mode_of_operation && showJointholderFlow == null) {
      return <AddJointHolderModal />;
    }
  }
  return (
    <React.Fragment>
      <Title title="Review Screen" />
      {dataSource ? (
        <div className="row">
          <div className="col-md-9">
            {dataSource.poi?.length > 0 && (
              <div
                className="col-md-12 card border mt-3 p-0"
                id="review-1"
              >
                <div className="card-header">
                  <h3
                    style={{ color: inputLabelColor }}
                    className="m-0"
                  >
                    Proof of Identity
                  </h3>
                </div>
                {(dataSource.poi || [])
                  .filter((resp) => resp.poi_type === "PAN")
                  .map((result, index) => {
                    return (
                      <div
                        className="row"
                        key={index}
                        style={{ paddingLeft: "12px", paddingRight: "12px" }}
                      >
                        <div className="col-md-6 border-bottom py-1">
                          <label style={{ color: inputLabelColor }}>Type</label>
                          <div>{result.poi_type}</div>
                        </div>
                        <div className="col-md-6 border-bottom py-1">
                          <label style={{ color: inputLabelColor }}>
                            PAN Number
                          </label>
                          <div>{result.pan_number}</div>
                        </div>
                        <div className="col-md-6 border-bottom py-1">
                          <label style={{ color: inputLabelColor }}>
                            Full Name
                          </label>
                          <div>{result.full_name}</div>
                        </div>
                        <div className="col-md-6 border-bottom py-1">
                          <label style={{ color: inputLabelColor }}>DOB</label>
                          <div>{result.dob}</div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            )}

            {dataSource.poa?.length > 0 && (
              <div
                className="col-md-12 card border mt-3 p-0"
                id="review-2"
              >
                <div className="card-header">
                  <h3
                    style={{ color: inputLabelColor }}
                    className="m-0"
                  >
                    Proof of Address
                  </h3>
                </div>
                {(dataSource.poa || []).map((result, index) => {
                  return (
                    <div
                      className="row"
                      key={index}
                      style={{ paddingLeft: "12px", paddingRight: "12px" }}
                    >
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>Type</label>
                        <div>{result.poa_type}</div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>
                          Full Name
                        </label>
                        <div>{result.full_name}</div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>DOB</label>
                        <div>{result.dob}</div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {getSegmentList()?.length > 0 && (
              <div
                className="col-md-12 card border mt-3 table-responsive p-0"
                id="review-3"
              >
                <div className="card-header">
                  <h3
                    style={{ color: inputLabelColor }}
                    className="m-0"
                  >
                    Segments
                  </h3>
                </div>
                <table>
                  <thead>
                    <tr style={{ color: inputLabelColor }}>
                      <th>Segment</th>
                      {getSegmentList().some((y) => y.bse) && <th>BSE</th>}
                      {getSegmentList().some((y) => y.nse) && <th>NSE</th>}
                      {getSegmentList().some((y) => y.mcx) && <th>MCX</th>}
                      {getSegmentList().some((y) => y.msei) && <th>MSEI</th>}
                      {getSegmentList().some((y) => y.ncdex) && <th>NCDEX</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {getSegmentList().map((result, index) => {
                      return (
                        <tr key={index}>
                          <td>{result.segment}</td>
                          {getSegmentList().some((y) => y.bse) && (
                            <td className={result.bse ? "bg-success" : ""}>
                              &nbsp;
                            </td>
                          )}
                          {getSegmentList().some((y) => y.nse) && (
                            <td className={result.nse ? "bg-success" : ""}>
                              &nbsp;
                            </td>
                          )}
                          {getSegmentList().some((y) => y.mcx) && (
                            <td className={result.mcx ? "bg-success" : ""}>
                              &nbsp;
                            </td>
                          )}
                          {getSegmentList().some((y) => y.msei) && (
                            <td className={result.msei ? "bg-success" : ""}>
                              &nbsp;
                            </td>
                          )}
                          {getSegmentList().some((y) => y.ncdex) && (
                            <td className={result.ncdex ? "bg-success" : ""}>
                              &nbsp;
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}

            {dataSource.communication_address?.length > 0 && (
              <div
                className="col-md-12 card border mt-3 p-0"
                id="review-4"
              >
                <div className="card-header">
                  <h3
                    style={{ color: inputLabelColor }}
                    className="m-0"
                  >
                    Communication Address
                  </h3>
                </div>
                {(dataSource.communication_address || []).map(
                  (result, index) => {
                    return (
                      <div
                        className="row"
                        key={index}
                        style={{ paddingLeft: "12px", paddingRight: "12px" }}
                      >
                        <div className="col-md-6 border-bottom py-1">
                          <label style={{ color: inputLabelColor }}>
                            Address Line 1
                          </label>
                          <div>{result.address_line1}</div>
                        </div>
                        <div className="col-md-6 border-bottom py-1">
                          <label style={{ color: inputLabelColor }}>
                            Pin Code
                          </label>
                          <div>{result.pincode}</div>
                        </div>
                        <div className="col-md-6 border-bottom py-1">
                          <label style={{ color: inputLabelColor }}>City</label>
                          <div>{result.city}</div>
                        </div>
                        <div className="col-md-6 border-bottom py-1">
                          <label style={{ color: inputLabelColor }}>
                            State
                          </label>
                          <div>{result.state}</div>
                        </div>
                        <div className="col-md-6 border-bottom py-1">
                          <label style={{ color: inputLabelColor }}>
                            Country
                          </label>
                          <div>{result.country}</div>
                        </div>
                        <div className="col-md-6 border-bottom py-1">
                          <label style={{ color: inputLabelColor }}>
                            Primary Address
                          </label>
                          <div>{result.is_primary === 1 ? "YES" : "NO"}</div>
                        </div>
                      </div>
                    );
                  }
                )}
              </div>
            )}

            {dataSource.kyc_detail?.length > 0 && (
              <div
                className="col-md-12 card border mt-3 p-0"
                id="review-5"
              >
                <div className="card-header">
                  <h3
                    style={{ color: inputLabelColor }}
                    className="m-0"
                  >
                    Personal Data
                  </h3>
                </div>
                {(dataSource.kyc_detail || []).map((result, index) => {
                  return (
                    <div
                      className="row"
                      key={index}
                      style={{ paddingLeft: "12px", paddingRight: "12px" }}
                    >
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>Name</label>
                        <div>{result.full_name}</div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>
                          Fathers Name
                        </label>
                        <div>{result.fathers_name}</div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>
                          Mothers Name
                        </label>
                        <div>{result.mothers_name}</div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>
                          Marital Status
                        </label>
                        <div>{result.marital_status}</div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>Gender</label>
                        <div>{result.gender}</div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>
                          Occupation
                        </label>
                        <div>{result.occupation}</div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>
                          Annual Income
                        </label>
                        <div>{result.annual_income_detail}</div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>Phone</label>
                        <div>{result.phone}</div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>
                          Years of experience
                        </label>
                        <div>
                          {result.years_of_experience_in_stock_commodity_market}
                        </div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>
                          Political Exposed Person ?{" "}
                        </label>
                        <div>
                          {result.politically_exposed_person_declaration}
                        </div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>BSDA </label>
                        <div>{result.bsda_confirmation_for_demat}</div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>
                          Electronic Contract Note confirmation on email ?{" "}
                        </label>
                        <div>
                          {
                            result.electronic_contract_note_confirmation_on_email
                          }
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {dataSource.nomination_details?.length > 0 && (
              <div
                className="col-md-12 card border mt-3 p-0"
                id="review-6"
              >
                <div className="card-header">
                  <h3
                    style={{ color: inputLabelColor }}
                    className="m-0"
                  >
                    Nomination details
                  </h3>
                </div>
                <div
                  className="row"
                  style={{ paddingLeft: "12px", paddingRight: "12px" }}
                >
                  {(dataSource.nomination_details || []).map(
                    (result, index) => {
                      return (
                        <>
                          <div className="row">
                            <div className="border-bottom border-secondary py-3">
                              <strong>Nominee {index + 1}</strong>
                            </div>
                            <div className="col-md-6 border-bottom py-1">
                              <label style={{ color: inputLabelColor }}>
                                Name
                              </label>
                              <div>{result.nominee_name}</div>
                            </div>
                            {result.email_id && (
                              <div className="col-md-6 border-bottom py-1">
                                <label style={{ color: inputLabelColor }}>
                                  Email
                                </label>
                                <div>{result.email_id}</div>
                              </div>
                            )}
                            <div className="col-md-6 border-bottom py-1">
                              <label style={{ color: inputLabelColor }}>
                                Phone
                              </label>
                              <div>{result.mobile}</div>
                            </div>
                            <div className="col-md-6 border-bottom py-1">
                              <label style={{ color: inputLabelColor }}>
                                Date of birth
                              </label>
                              <div>{result.nominee_dob}</div>
                            </div>
                            <div className="col-md-6 border-bottom py-1">
                              <label style={{ color: inputLabelColor }}>
                                Relationship with applicant
                              </label>
                              <div>{result.relationship_with_applicant}</div>
                            </div>
                            {result?.relationship_with_nomiee && (
                              <div className="col-md-6 border-bottom py-1">
                                <label style={{ color: inputLabelColor }}>
                                  Relationship with Nominee
                                </label>
                                <div>{result.relationship_with_nomiee}</div>
                              </div>
                            )}
                            {result?.other_relationship && (
                              <div className="col-md-6 border-bottom py-1">
                                <label style={{ color: inputLabelColor }}>
                                  Other relationship
                                </label>
                                <div>{result.other_relationship}</div>
                              </div>
                            )}
                            {result.type_of_identification && (
                              <div className="col-md-6 border-bottom py-1">
                                <label style={{ color: inputLabelColor }}>
                                  Type of identification
                                </label>
                                <div>{result.type_of_identification}</div>
                              </div>
                            )}
                            <div className="col-md-6 border-bottom py-1">
                              <label style={{ color: inputLabelColor }}>
                                Share of nominee
                              </label>
                              <div>{result.share_of__nominee}</div>
                            </div>
                            <div className="col-md-12 border-bottom">
                              <label style={{ fontWeight: "500" }}>
                                Address
                              </label>
                              <div>{getAddress(result)}</div>
                            </div>
                            <div className="col-md-6 border-bottom py-1">
                              <label style={{ color: inputLabelColor }}>
                                Minor
                              </label>
                              <div>{result.minor === 0 ? "No" : "Yes"}</div>
                            </div>
                            {result.minor === 1 && (
                              <>
                                <h5 className="mt-1">Guardian Details</h5>
                                <div className="col-md-6 border-bottom py-1">
                                  <label style={{ color: inputLabelColor }}>
                                    Name
                                  </label>
                                  <div>{result.guardian_name}</div>
                                </div>
                                {result.guardian_email && (
                                  <div className="col-md-6 border-bottom py-1">
                                    <label style={{ color: inputLabelColor }}>
                                      Email
                                    </label>
                                    <div>{result.guardian_email}</div>
                                  </div>
                                )}
                                <div className="col-md-6 border-bottom py-1">
                                  <label style={{ color: inputLabelColor }}>
                                    Phone
                                  </label>
                                  <div>{result.guardian_mobile}</div>
                                </div>
                                <div className="col-md-6 border-bottom py-1">
                                  <label style={{ color: inputLabelColor }}>
                                    Date of birth
                                  </label>
                                  <div>{result.guardian_dob}</div>
                                </div>
                                <div className="col-md-6 border-bottom py-1">
                                  {result.id_type && (
                                    <>
                                      <label style={{ color: inputLabelColor }}>
                                        Guardian Type of identification
                                      </label>
                                      <div>{result.id_type}</div>
                                    </>
                                  )}
                                </div>
                                {result.guardian_address1 && (
                                  <div className="col-md-12 border-bottom py-1">
                                    <label style={{ color: inputLabelColor }}>
                                      Address
                                    </label>
                                    <div>{getGuardianAddress(result)}</div>
                                  </div>
                                )}
                              </>
                            )}
                          </div>
                        </>
                      );
                    }
                  )}
                </div>
              </div>
            )}
            {dataSource.joint_holder.secound_holder.consent ?
              <div
                className="col-md-12 card border mt-3 p-0"
                id="review-7"
              >
                <div className="card-header">
                  <h3
                    style={{ color: inputLabelColor }}
                    className="m-0"
                  >
                    JointHolder (Second Holder)
                  </h3>
                </div>
                <div
                  className="row"

                  style={{ paddingLeft: "12px", paddingRight: "12px" }}
                >
                  <div className="col-md-6 border-bottom py-1">
                    <label style={{ color: inputLabelColor }}>
                      Full Name
                    </label>
                    <div>{dataSource.joint_holder.secound_holder.name_as_per_pan}</div>
                  </div>
                  <div className="col-md-6 border-bottom py-1">
                    <label style={{ color: inputLabelColor }}>
                      PAN Number
                    </label>
                    <div>{dataSource.joint_holder.secound_holder.pan_number}</div>
                  </div>
                  <div className="col-md-6 border-bottom py-1">
                    <label style={{ color: inputLabelColor }}>
                      Date of Birth
                    </label>
                    <div>{dataSource.joint_holder.secound_holder.dob}</div>
                  </div>
                </div>
              </div> : null
            }
            {dataSource.joint_holder.third_holder.consent ?
              <div
                className="col-md-12 card border mt-3 p-0"
                id="review-7"
              >
                <div className="card-header">
                  <h3
                    style={{ color: inputLabelColor }}
                    className="m-0"
                  >
                    JointHolder (Third Holder)
                  </h3>
                </div>
                <div
                  className="row"

                  style={{ paddingLeft: "12px", paddingRight: "12px" }}
                >
                  <div className="col-md-6 border-bottom py-1">
                    <label style={{ color: inputLabelColor }}>
                      Full Name
                    </label>
                    <div>{dataSource.joint_holder.third_holder.name_as_per_pan}</div>
                  </div>
                  <div className="col-md-6 border-bottom py-1">
                    <label style={{ color: inputLabelColor }}>
                      PAN Number
                    </label>
                    <div>{dataSource.joint_holder.third_holder.pan_number}</div>
                  </div>
                  <div className="col-md-6 border-bottom py-1">
                    <label style={{ color: inputLabelColor }}>
                      Date of Birth
                    </label>
                    <div>{dataSource.joint_holder.third_holder.dob}</div>
                  </div>
                </div>
              </div > : null
            }

            {dataSource.bank_details?.length > 0 && (
              <div
                className="col-md-12 card border mt-3 p-0"
                id="review-7"
              >
                <div className="card-header">
                  <h3
                    style={{ color: inputLabelColor }}
                    className="m-0"
                  >
                    Bank details
                  </h3>
                </div>
                {(dataSource.bank_details || []).map((result, index) => {
                  return (
                    <div
                      className="row"
                      key={index}
                      style={{ paddingLeft: "12px", paddingRight: "12px" }}
                    >
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>
                          Account Type
                        </label>
                        <div>{result.account_type}</div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>
                          Account Name
                        </label>
                        <div>
                          {result.account_name || result.registered_name}
                        </div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>
                          Bank Name
                        </label>
                        <div>
                          {result.bank_name || result.verified_bank_name}
                        </div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>
                          Account Number
                        </label>
                        <div>
                          {result.ac_number || result.verified_account_number}
                        </div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>Branch</label>
                        <div>{result.branch || result.verified_branch}</div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>
                          IFSC Code
                        </label>
                        <div>{result.ifsc || result.verified_ifsc}</div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>
                          MICR Code
                        </label>
                        <div>{result.micr_code}</div>
                      </div>
                      <div className="col-md-6 border-bottom py-1">
                        <label style={{ color: inputLabelColor }}>
                          Verified Bank Account
                        </label>
                        <div>
                          {result.verified_bank_account === 1 ? "Yes" : "No"}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {getApiUrl() !== "https://scmcbrkg.in" &&
              getApiUrl() != CONSORTIUM_API_URL &&
              dataSource.tariff_details?.length > 0 && (
                <>
                  {(dataSource.tariff_details || []).map((result, index) => {
                    if (!(result?.tariff_sheet_charges || [])?.length) {
                      return null;
                    }
                    return (
                      <div
                        className="col-md-12 card border mt-3 p-0"
                        id="review-8"
                      >
                        <div className="card-header">
                          <h3
                            style={{ color: inputLabelColor }}
                            className="m-0"
                          >
                            Tariff details
                          </h3>
                        </div>
                        <div
                          className="row"
                          key={index}
                          style={{ paddingLeft: "12px", paddingRight: "12px" }}
                        >
                          <div className="col-md-12 border-bottom py-1">
                            <label
                              style={{ color: inputLabelColor }}
                              className="py-2"
                            >
                              Tariff sheet charges
                            </label>
                            <div>
                              <div className="ql-editor read-mode">
                                <table className="table table-bordered">
                                  <tbody>
                                    {(result?.tariff_sheet_charges || []).map(
                                      (item, i) => {
                                        return (
                                          <tr key={i}>
                                            <td>
                                              <span>{item.type_of_charge}</span>
                                            </td>
                                            <td>
                                              <span>{item.amount_detail}</span>
                                            </td>
                                          </tr>
                                        );
                                      }
                                    )}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                          {/* <div className="col-md-12 border-bottom py-1">
                            <label style={{ color: inputLabelColor }}>
                              Tariff sheet charges on depository
                            </label>
                            <div
                              dangerouslySetInnerHTML={{
                                __html:
                                  result.tariff_sheet_charges_on_depository,
                              }}
                            ></div>
                          </div> */}
                        </div>
                      </div>
                    );
                  })}
                </>
              )}

            {getApiUrl() === "https://scmcbrkg.in" && (
              <div
                className="col-md-12 card border mt-3 p-0"
                id="review-8"
              >
                <div className="card-header">
                  <h3
                    style={{ color: inputLabelColor }}
                    className="m-0"
                  >
                    Tariff details
                  </h3>
                </div>
                <div
                  className="row"
                  style={{ paddingLeft: "12px", paddingRight: "12px" }}
                >
                  <div className="col-md-6 border-bottom py-1">
                    <label style={{ color: inputLabelColor }}>
                      Tariff details:
                    </label>
                  </div>
                  <div className="col-md-6 border-bottom py-1">
                    <div>{dataSource?.tariff_details}</div>
                  </div>
                </div>
              </div>
            )}

            {dataSource.ddpi_details?.length > 0 && (
              <div
                className="col-md-12 card border mt-3 p-0"
                id="review-1"
              >
                <div className="card-header">
                  <h3
                    style={{ color: inputLabelColor }}
                    className="m-0"
                  >
                    DDPI Details
                  </h3>
                </div>

                <div
                  className="row"
                  style={{ paddingLeft: "12px", paddingRight: "12px" }}
                >
                  <div className="col-md-6 border-bottom py-1">
                    <label style={{ color: inputLabelColor }}>
                      Transfer of securities held in the beneficial owner
                      accounts of the client towards Stock Exchange related
                      deliveries / settlement obligations arising out of trades
                      executed by clients on the Stock Exchange through the same
                      stock broker.
                    </label>
                    <div>
                      {dataSource.ddpi_details[0]?.ddpi_question_1 === 1
                        ? "Yes"
                        : "No"}
                    </div>
                  </div>
                  <div className="col-md-6 border-bottom py-1">
                    <label style={{ color: inputLabelColor }}>
                      Pledging / re-pledging of securities in favour of trading
                      member (TM) / clearing member (CM) for the purpose of
                      meeting margin requirements of the clients in connection
                      with the trades executed by the clients on the Stock
                      Exchange.
                    </label>
                    <div>
                      {dataSource.ddpi_details[0]?.ddpi_question_2 === 1
                        ? "Yes"
                        : "No"}
                    </div>
                  </div>
                  <div className="col-md-6 border-bottom py-1">
                    <label style={{ color: inputLabelColor }}>
                      Mutual Fund transactions being executed on Stock Exchange
                      order entry platforms.
                    </label>
                    <div>
                      {dataSource.ddpi_details[0]?.ddpi_question_3 === 1
                        ? "Yes"
                        : "No"}
                    </div>
                  </div>
                  <div className="col-md-6 border-bottom py-1">
                    <label style={{ color: inputLabelColor }}>
                      Tendering shares in open offers through Stock Exchange
                      platforms.
                    </label>
                    <div>
                      {dataSource.ddpi_details[0]?.ddpi_question_4 === 1
                        ? "Yes"
                        : "No"}
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div
              className="col-md-12 d-flex mt-3"
              id="review-9"
            >
              {showPrevBtnByUrl(
                history.location.pathname,
                kycStatus,
                kycPageName
              ) && (
                  <Button
                    title="Previous"
                    type="button"
                    className="mx-1"
                    handleClick={() => {
                      const route = getPrevAndNextRoute(
                        history.location.pathname.slice(1),
                        kycPageName
                      );
                      history.push(route.prev);
                    }}
                  />
                )}
              <Button
                type="button"
                title="Submit"
                className="mx-1"
                handleClick={handleSubmit}
              />
            </div>
          </div>
          <div className="col-md-3">
            {!["108"].includes(themeTemplate) && (
              <div style={getArrowStyle(themeTemplate)}>
                <button
                  className="btn btn-light mx-2"
                  style={{ fontSize: "20px", cursor: "pointer" }}
                  onClick={() => goToTop()}
                >
                  <i className="fa fa-regular fa-arrow-up"></i>
                </button>
                <button
                  className="btn btn-light mx-2"
                  style={{ fontSize: "20px" }}
                  onClick={() => goToBottom()}
                >
                  <i className="fa fa-regular fa-arrow-down"></i>
                </button>
              </div>
            )}
          </div>
        </div>
      ) : (
        <h6
          className="col-md-12 mt-3 text-center"
          style={{ color: inputLabelColor }}
        >
          {loading ? "Loading..." : "No Record Found..."}
        </h6>
      )}
    </React.Fragment>
  );
};

export default Review;
